import type { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
  className?: string
}

// Wrapping bare text in a real element gives React a stable DOM node to track,
// so browser extensions like Google Translate that swap text nodes don't break
// reconciliation (the source of `Failed to execute 'removeChild' on 'Node'`).
export const Text: FC<Props> = ({ children, className }) => (
  <span className={className}>{children}</span>
)
